import React, { useEffect } from 'react'
import { useMutation } from 'react-query'
import { api } from '../../api/jointExam'
import toast from 'react-hot-toast'
import { clearFlaggedQuestion } from '../../features/candidate-exam/candidate-exam-slice'
import { use } from 'chai'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { convertTo12Hour } from '../../utils/dateTimeFormatter'
import Loader from '../../components/loader/Loader'
import { useTranslation } from 'react-i18next'

const ViewAssessments = () => {

  const userData = JSON.parse(sessionStorage.getItem("userExamData")!)
  const {isLoading, mutateAsync} = useMutation(api.initiateAssessment)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {t} = useTranslation()
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from');
  const user = JSON.parse(sessionStorage.getItem('user')!)
  const defaultAssessments = JSON.parse(sessionStorage.getItem('assessments')!)
  const [assessments, setAssessments] = React.useState<any[]>( 
     defaultAssessments?.length ? defaultAssessments :
    []
    );
  const {mutate: checkExam, isLoading: checkLoading} = useMutation(api.checkExam, {
    onSuccess: (data) => {
       setAssessments(data?.data?.assessments)
    }
  })


   useEffect(() => {
    if(from === 'assessment'){
       checkExam({
        id: userData?.id,
        payload: {
          email: sessionStorage.getItem("userEmail"),
          type: 'check',
          name: user?.name
        }
       })
    }
   }, [])

    const startExam = async (assessment: any) => {
      const currentAssessment = assessments?.find((item: any) => item?.id === assessment?.id)
       if(currentAssessment?.completed_at && ( currentAssessment?.attempts_made >= currentAssessment?.number_of_attempts)){
         return toast.error('You have reached the maximum number of attempts for this assessment.');
       }
       try{
        const response = await mutateAsync({
          id: userData?.id,
          payload: {
            user_id: sessionStorage.getItem('user_id'),
            exam_id: assessment?.exam_id,
            assessment_id: assessment?.id
          }
        });
        sessionStorage.setItem("guestUserExamId", response?.data?.user?.user_exam_id as string);
        dispatch(clearFlaggedQuestion(null));
        sessionStorage.setItem('attempt_count', response?.data?.exam?.number_of_attempts)
        window.sessionStorage.setItem("active-assessment-id", response?.data?.user?.exam_id);
        window.sessionStorage.setItem("active-assessment-user-id", response?.data?.user?.user_exam_id);
        window.sessionStorage.setItem("active-assessment", JSON.stringify(response?.data?.exam));
        window.sessionStorage.setItem("time_left", response?.data?.exam?.time_left);
        window.sessionStorage.setItem("duration", response?.data?.exam?.duration);
        window.sessionStorage.setItem("ql", response?.data?.exam?.number_of_questions);
        window.sessionStorage.setItem("starting-index", response?.data?.exam?.number_of_questions_answered);
        // navigate("/candidate/assessments/instructions");
        if (response?.data?.show_candidate_result) {
          return navigate('/candidate/exam-history');
        }
        sessionStorage.setItem("loginType", 'join');
        sessionStorage.setItem("joinType", 'normal');
         sessionStorage.setItem("rejoinUser", '0')
        if(!response?.data?.redirect_to_results) {
          return navigate('/candidate/assessments/instructions')
        }
        if (response?.data?.exam?.number_of_attempts < response?.data?.exam?.number_of_attempts_allowed) {
          sessionStorage.setItem('attempt_count', response?.data?.exam?.number_of_attempts)
          navigate(`/candidate/assessments/instructions`)
        } else {
          navigate('/candidate/exam-history')
        }
       }
       catch(e: any){
         toast.error(e?.response?.data?.message);
       }
    }

    if(from === 'assessment' && checkLoading){
      return <Loader />
    }

  return (
    <div>
       <header className="bg-darkBlue max-[500px]:mt-5 md:flex justify-between items-center py-3 px-4 rounded-md mb-4">
                  <h1 className="text-white max-[500px]:mb-3 text-lg">
                     {userData?.title}
                  </h1>
            </header>
       <section className='grid grid-cols-1 md:grid-cols-2 gap-5'> 
             {
        userData?.assessments?.map((assessment: any) => {
          const currentAssessment = assessments?.find((item: any) => item?.id === assessment?.id)
          const isCompleted = currentAssessment?.completed_at && ( currentAssessment?.attempts_made >= currentAssessment?.number_of_attempts)
          return (
            <ul      
              key={assessment?.id}
              className="border bg-white border-gray-300 rounded-lg mb-8 p-0"
                          >
                            <li className="flex justify-between py-4 px-4">
                              <span className="text-lg">Exam Title:&nbsp;</span>
                              <span className="text-lg">
                                {assessment?.preferred_exam_title}
                              </span>
                            </li>
                            <li className="flex justify-between py-4 px-4">
                              <span className="text-lg">Duration:&nbsp;</span>
                              <span className="text-lg">
                                { 
                                  assessment?.duration  
                                } mins
                              </span>
                            </li>
                            <li className="flex justify-between py-4 px-4">
                              <span className="text-lg">Start Date & Time:&nbsp;</span>
                              <span className="text-lg">
                                { 
                                  new Date(assessment?.start_date).toLocaleDateString('en-ng') 
                                }
                                {' '} {convertTo12Hour(assessment?.start_time)}
                              </span>
                            </li>
                            <li className="flex justify-between py-4 px-4">
                              <span className="text-lg">End Date & Time:&nbsp;</span>
                              <span className="text-lg">
                                { 
                                  new Date(assessment?.end_date).toLocaleDateString('en-ng') 
                                }
                                {' '} {convertTo12Hour(assessment?.end_time)}
                              </span>
                            </li>
                            <li className="flex justify-between p-3">
                              <span className="text-lg">Action:&nbsp;</span>
                              <div className="flex gap-3">
                                <Link 
                                    to={`/candidate/results/${currentAssessment?.exam_id}?userExamId=${currentAssessment?.user_exam_id}`}
                                    className="text-white bg-darkBlue hover:bg-primary-focus focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg px-3 py-2.5 text-center"
                                    onClick={() => {
                                      sessionStorage.setItem('activeExam', assessment?.preferred_exam_title)
                                      sessionStorage.setItem('isAllowed', 
                                        isCompleted ? '0' : '1'
                                      )
                                      sessionStorage.setItem('attempt_count', currentAssessment?.number_of_attempts) 
                                    }}
                                  >
                                    {t('view-result')}
                                  </Link>
                               <span 
                               onClick={() => startExam(assessment)}
                                className={`text-lg hover:cursor-pointer ${
                                  isCompleted ? 'bg-gray-200' : 'bg-primary text-white'
                                } py-3 px-8 rounded-lg`}>
                                 {isCompleted ? 'Completed' : 'Start Exam'}
                              </span>
                              </div>
                            </li>
                </ul>
          )
        })
       }
       </section>
    </div>
  )
}

export default ViewAssessments